export default __webpack_public_path__ + "static/asiapacific2019silver-0eaa7cf2c2dfe25e9de6248c6b23d8bd.jpg";